module.exports = __webpack_public_path__ + "img/mastercard.355a671f.png";